<script setup>
import PayrollTableRow from './PayrollTableRow.vue';
</script>

<template>
    <div class="column">
        <div class="grid">
          <div class="column">
            <h1 class="is-size-4 mb-5">{{ payroll.account.name }}</h1>
            <table class="table is-hoverable is-fullwidth has-text-left">
              <thead>
                <tr class="payroll-table-tr">
                  <th>Sequência</th>
                  <th>Vencimento</th>
                  <th>Principal</th>
                  <th>FGTS (8%)</th>
                  <th>Correção (TR)</th>
                  <th>Selic</th>
                  <th>Juros</th>
                  <th>Subtotal</th>
                </tr>
              </thead>

              <tbody>
                <PayrollTableRow v-for="(payment, index) in payroll.payments" v-bind:key="(payment.date + payment.sequence)" :payment="payment" :edit="edit" :index="index"/>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td v-if="!edit" class="has-text-weight-bold">{{ getCurrency(totalValue) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['payroll', 'edit'],
  methods: {
    getCurrency(value) {
      if (value === null || isNaN(value)) return '';
      return value.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    },
    paymentTotalValue(payment) {
      const total = (payment.value * 0.08)
        * (payment.tr ? 1 + payment.tr : 1)
        * (payment.selic ? 1 + payment.selic : 1)
        * (payment.poupanca ? 1 + payment.poupanca : 1);

        return total;
    }
  }, computed: {
    totalValue() {
      return  this.payroll.payments.reduce((partialSum, payment) => partialSum + this.paymentTotalValue(payment), 0);
    }
  }
}
</script>

<style>
  tr.payroll-table-tr th {
    font-size: 14px;
  }
</style>